import {
  useCompositeSeparator
} from "../__chunks/RY6ZOIHR.js";
import "../__chunks/D3IXN5NP.js";
import "../__chunks/WJ37OVG2.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import "../__chunks/PNRLI7OV.js";

// src/toolbar/toolbar-separator.ts
var useToolbarSeparator = createHook(
  (props) => {
    props = useCompositeSeparator(props);
    return props;
  }
);
var ToolbarSeparator = createComponent(
  (props) => {
    const htmlProps = useToolbarSeparator(props);
    return createElement("hr", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  ToolbarSeparator.displayName = "ToolbarSeparator";
}
export {
  ToolbarSeparator,
  useToolbarSeparator
};
